/**
 * Resolve My Links thumb cover frame for Line/Grid templates.
 * Prefers live contentEdits (editor drag), then persisted `image_crop.coverFrame`.
 */
import type { CSSProperties } from "react";
import { useEdit } from "./InlineEdit";
import {
  bannerImageFrameStyle,
  imageFrameEditKey,
  parseImageFrameEdit,
  readLinkCoverFrame,
  type BannerImageFrame,
} from "./templateBannerUtils";

export function userLinkThumbSlot(linkId: string | number): string {
  return `user-link-${linkId}-thumb`;
}

export function useLinkThumbCoverStyle(
  linkId: string | number | null | undefined,
  imageCrop: unknown,
): CSSProperties | undefined {
  const { get } = useEdit();
  const id = linkId != null ? String(linkId).trim() : "";
  const fromEdits = id
    ? parseImageFrameEdit(get(imageFrameEditKey(userLinkThumbSlot(id)), ""))
    : null;
  const fromCrop = readLinkCoverFrame(imageCrop);
  const frame: BannerImageFrame | null = fromEdits || fromCrop;
  return frame
    ? bannerImageFrameStyle(frame, { objectFit: "contain" })
    : undefined;
}
